/* ═══════════════════════════════════════════════════════════════
   Analytics consent (GDPR / CNIL) — shared by the landing page and the web app.

   Google Analytics is NOT loaded until the visitor explicitly accepts. The
   choice is stored once per origin (localStorage "analytics-consent" =
   "granted" | "denied"), so answering on the landing page also covers /app.
   Refusing is one click, same as accepting. Native mobile (window.__isMobile)
   and Electron (window.api) never load GA, so they never show the banner.

   window.ptOpenConsent() re-opens the banner (footer "Cookie settings" link).
   ═══════════════════════════════════════════════════════════════ */
(function () {
  if (window.api || window.__isMobile) return;

  var KEY = "analytics-consent";
  var GA_ID = "G-6M52V64VWJ";

  var STRINGS = {
    en: {
      text: "We use Google Analytics cookies to understand how Pocket Tracker is used. No ads, no data selling.",
      accept: "Accept",
      decline: "Decline",
      policy: "Cookie Policy",
    },
    fr: {
      text: "Nous utilisons des cookies Google Analytics pour comprendre comment Pocket Tracker est utilisé. Aucune publicité, aucune revente de données.",
      accept: "Accepter",
      decline: "Refuser",
      policy: "Politique des cookies",
    },
    ja: {
      text: "Pocket Trackerの利用状況を把握するため、Google Analyticsのクッキーを使用しています。広告なし・データ販売なし。",
      accept: "許可する",
      decline: "拒否する",
      policy: "Cookieポリシー",
    },
  };

  function getChoice() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function setChoice(v) {
    try { localStorage.setItem(KEY, v); } catch (e) { /* private mode: ask again next visit */ }
  }

  function lang() {
    var m = location.pathname.match(/^\/(fr|ja)(\/|$)/);
    if (m) return m[1];
    var stored = null;
    try { stored = localStorage.getItem("ui-lang"); } catch (e) { /* ignore */ }
    if (stored && STRINGS[stored]) return stored;
    var nav = (navigator.language || "en").slice(0, 2);
    return STRINGS[nav] ? nav : "en";
  }

  // The app's index.html defines a queueing gtag stub up front (so analytics.js
  // calls never throw); define it here too for the landing page.
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  var gaLoaded = false;
  function loadGA() {
    if (gaLoaded) return;
    gaLoaded = true;
    gtag("consent", "default", { analytics_storage: "granted" });
    gtag("js", new Date());
    gtag("config", GA_ID);
    var s = document.createElement("script");
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + GA_ID;
    s.async = true;
    document.head.appendChild(s);
  }
  // Keep GA off the critical path (it parses on the main thread).
  function loadGADeferred() {
    if ("requestIdleCallback" in window) requestIdleCallback(loadGA, { timeout: 4000 });
    else setTimeout(loadGA, 1500);
  }

  function clearGACookies() {
    var host = location.hostname;
    var domains = ["", host, "." + host, "." + host.split(".").slice(-2).join(".")];
    document.cookie.split(";").forEach(function (c) {
      var name = c.split("=")[0].trim();
      if (name !== "_ga" && name.indexOf("_ga_") !== 0) return;
      domains.forEach(function (d) {
        document.cookie = name + "=; Max-Age=0; path=/" + (d ? "; domain=" + d : "");
      });
    });
  }

  var STYLE =
    "#pt-consent{position:fixed;left:16px;right:16px;bottom:16px;z-index:10000;max-width:720px;margin:0 auto;" +
    "display:flex;align-items:center;gap:16px;flex-wrap:wrap;padding:14px 18px;border-radius:12px;" +
    "background:#1a1a2e;border:1px solid #3a3a5a;box-shadow:0 8px 32px rgba(0,0,0,.5);" +
    "color:#eaeaea;font:14px/1.5 'Segoe UI',system-ui,-apple-system,sans-serif}" +
    "#pt-consent p{flex:1 1 300px;margin:0;color:#b8b8c8}" +
    "#pt-consent a{color:#4da6ff;text-decoration:underline;text-underline-offset:2px}" +
    "#pt-consent .pt-consent-actions{display:flex;gap:10px;flex:0 0 auto;margin-left:auto}" +
    "#pt-consent button{height:36px;padding:0 18px;border-radius:4px;font:600 14px 'Segoe UI',system-ui,sans-serif;cursor:pointer;" +
    "background:rgba(144,144,176,.08);color:#eaeaea;border:1px solid rgba(144,144,176,.45)}" +
    "#pt-consent button:hover{background:rgba(144,144,176,.16);border-color:rgba(144,144,176,.8)}" +
    "@media (max-width:480px){#pt-consent{left:8px;right:8px;bottom:8px;padding:12px 14px}" +
    "#pt-consent .pt-consent-actions{width:100%}#pt-consent button{flex:1}}";

  function showBanner() {
    if (document.getElementById("pt-consent")) return;
    var L = lang();
    var t = STRINGS[L];
    if (!document.getElementById("pt-consent-style")) {
      var st = document.createElement("style");
      st.id = "pt-consent-style";
      st.textContent = STYLE;
      document.head.appendChild(st);
    }
    var policyHref = (L === "en" ? "" : "/" + L) + "/cookies";
    var el = document.createElement("div");
    el.id = "pt-consent";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-live", "polite");
    el.setAttribute("aria-label", t.policy);
    // Strings are static constants above, never user input.
    el.innerHTML =
      '<p>' + t.text + ' <a href="' + policyHref + '" target="_blank" rel="noopener">' + t.policy + '</a></p>' +
      '<div class="pt-consent-actions">' +
      '<button type="button" data-choice="denied">' + t.decline + '</button>' +
      '<button type="button" data-choice="granted">' + t.accept + '</button>' +
      '</div>';
    el.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-choice]");
      if (!btn) return;
      var choice = btn.getAttribute("data-choice");
      setChoice(choice);
      el.remove();
      if (choice === "granted") {
        loadGA();
      } else {
        if (gaLoaded) gtag("consent", "update", { analytics_storage: "denied" });
        clearGACookies();
      }
    });
    document.body.appendChild(el);
  }

  window.ptOpenConsent = function () {
    if (document.body) showBanner();
  };

  var choice = getChoice();
  if (choice === "granted") {
    loadGADeferred();
  } else if (choice !== "denied") {
    if (document.body) showBanner();
    else document.addEventListener("DOMContentLoaded", showBanner);
  }
})();
